import { render, staticRenderFns } from "./ChaseTheTrade.vue?vue&type=template&id=07acd49a&scoped=true&"
import script from "./ChaseTheTrade.vue?vue&type=script&lang=js&"
export * from "./ChaseTheTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07acd49a",
  null
  
)

export default component.exports